import get from "lodash/get";
import { StateGetterBase } from "./StateGetterBase";

const EMPTY_ARRAY = []
export class MenuStateGetter extends StateGetterBase {
    getMenu() {
        return get(this.state, "menu", EMPTY_ARRAY)
    }
}